var TorsoNestedModel = require('backbone-torso/modules/NestedModel');
var tempusPaymentDeviceExtService = require('./../../urls').tempusPaymentDeviceExtService;

/**
 * A Model representing a PaymentDevice from any payment processor.
 * @class PaymentDeviceModel
 * @extends TorsoNestedModel
 */
module.exports = TorsoNestedModel.extend({
  idAttribute: 'deviceId',
  urlRoot: tempusPaymentDeviceExtService
});
